import PropTypes from 'prop-types'
import Button from '@/shared/components/UI/Button'
import CheckCircleIcon from '@/shared/icons/CheckCircleIcon'

const BulletItem = ({ text }) => (
  <li className="flex items-center gap-v3-xs">
    <CheckCircleIcon className="text-v3-green-dark w-5 h-5 flex-shrink-0" />
    <span className="text-v3-black-secondary text-v3-h9 font-inter-variable">{text}</span>
  </li>
)

BulletItem.propTypes = {
  text: PropTypes.string.isRequired,
}

const StepBroken = ({ onContactSupport, onLeave }) => {
  return (
    <div className="flex flex-col gap-v3-md w-full">
      <h2 className="text-v3-h5 font-bold text-v3-black-max">
        We're sorry you've had a bad experience.
      </h2>

      <div className="rounded-v3-md border border-v3-card-border bg-v3-purple-bg p-v3-md flex flex-col gap-v3-sm">
        <div className="flex flex-col gap-v3-xs">
          <h3 className="text-v3-h6 font-bold text-v3-black-max">
            Let our team fix it for you
          </h3>
          <p className="text-v3-black-secondary text-v3-h9 font-inter-variable">
            Most issues are resolved in under 24 hours. Our support team has a 4.8/5 satisfaction
            rating.
          </p>
        </div>

        <ul className="flex flex-col gap-v3-xs">
          <BulletItem text="Priority support - skip the queue" />
          <BulletItem text="Screen-share sessions available" />
          <BulletItem text="We won't stop until it's working" />
        </ul>
      </div>

      <div className="flex flex-col items-center gap-v3-sm w-full">
        <Button
          variant="primary"
          size="lg"
          label="Talk to support now"
          onClick={onContactSupport}
        />
        <Button
          variant="transparent"
          label="I still want to cancel"
          onClick={onLeave}
        />
      </div>
    </div>
  )
}

StepBroken.propTypes = {
  onContactSupport: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
}

export default StepBroken
